import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
interface BannerPropsType extends GeneralPropsType {
  banner?: string;
  title?: string;
  des?: string;
  action?: string;
}
function Banner({
  children,
  className
}: BannerPropsType) {
  return <div className={clsx("border-2 w-[calc(100vw-76px)] max-w-[600px] aspect-[0.75] rounded-2xl", styles.container, className)} data-sentry-component="Banner" data-sentry-source-file="index.tsx">
            {children}
        </div>;
}
export default Banner;